import React from 'react';
import { 
  Shield, 
  Lock, 
  Database, 
  Share2, 
  ShieldCheck,
  AlertTriangle,
} from 'lucide-react';
import { Link } from 'react-router-dom';

const PoliticaPrivacidade = () => {
  const dataAtual = new Date().toLocaleDateString('pt-BR');

  return (
    <div className="min-h-screen bg-[#f8fafc] font-sans text-slate-700 py-12 px-6 sm:px-10 overflow-x-hidden">
      
      {/* CABEÇALHO */}
      <div className="max-w-3xl mx-auto mb-12 text-center">
        
        <Link to="/" className="inline-block transition-transform hover:scale-105">
          <img 
            src="/logo-sincro2.png" 
            alt="Agenda Sincro" 
            className="h-14 sm:h-16 w-auto mx-auto mb-6 object-contain"
          />
        </Link>
        
        <br/>
        <div className="inline-flex items-center justify-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-xs font-black uppercase tracking-widest">
          <ShieldCheck size={16} />
          Política de Privacidade (LGPD)
        </div>
        <p className="mt-6 text-sm font-medium text-slate-500">
          Versão 2.0 | Atualizado em: {dataAtual}
        </p>
      </div>

      <div className="max-w-3xl mx-auto flex flex-col gap-6">

        {/* INTRODUÇÃO E NATUREZA DOS DADOS */}
        <div className="bg-white p-8 sm:p-10 rounded-[32px] border border-slate-100 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.05)]">
          <h2 className="flex items-center gap-3 text-lg font-black text-slate-900 uppercase tracking-wide mb-4">
            <Database size={24} className="text-blue-600" /> 
            1. Coleta e Natureza dos Dados
          </h2>
          <p className="text-sm leading-relaxed text-slate-600 font-medium mb-4">
            O <strong>Agenda Sincro</strong>, mantido pela Futurae Tecnologia e Consultoria, atua tecnicamente como <strong>Operador de Dados</strong>, processando informações sob a instrução direta do Usuário (Controlador). Nós coletamos e processamos:
          </p>
          <ul className="flex flex-col gap-3 text-sm text-slate-600 font-medium bg-slate-50 p-6 rounded-2xl">
            <li className="flex items-start gap-2">
              <span className="text-blue-500 mt-0.5">▪</span>
              <div><strong>Escopo Google OAuth:</strong> Acessamos exclusivamente permissões restritas como calendários para sincronização. Não lemos e-mails privados ou outros arquivos não relacionados ao agendamento.</div>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-blue-500 mt-0.5">▪</span>
              <div><strong>Dados de Terceiros (Clientes):</strong> Nome, telefone e detalhes da consulta. O Usuário garante possuir a base legal necessária para fornecer e trafegar esses dados na plataforma.</div>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-blue-500 mt-0.5">▪</span>
              <div><strong>Dados de Sessão:</strong> Logs técnicos de comunicação entre a Evolution API e nossos servidores para fins estritos de debugging, suporte e métricas de desempenho.</div>
            </li>
          </ul>
        </div>

        {/* SEGURANÇA E CRIPTOGRAFIA */}
        <div className="bg-white p-8 sm:p-10 rounded-[32px] border border-slate-100 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.05)]">
          <h2 className="flex items-center gap-3 text-lg font-black text-slate-900 uppercase tracking-wide mb-4">
            <Shield size={24} className="text-emerald-500" /> 
            2. Segurança e Criptografia
          </h2>
          <p className="text-sm leading-relaxed text-slate-600 font-medium mb-6">
            Implementamos rígidas medidas de segurança padrão de mercado, incluindo criptografia SSL/TLS em trânsito e proteção de banco de dados em repouso. Nosso compromisso é manter a integridade das informações da sua agenda.
          </p>
          
          <div className="bg-amber-50 p-6 rounded-2xl border border-amber-200">
            <h3 className="flex items-center gap-2 text-[13px] font-black text-amber-800 uppercase tracking-wide mb-2">
              <AlertTriangle size={16} /> Isenção de Responsabilidade
            </h3>
            <p className="text-[13px] leading-relaxed text-amber-900 font-medium m-0">
              Apesar de nossos melhores esforços, o Usuário reconhece que nenhum sistema de transmissão via internet é 100% impenetrável. Não nos responsabilizamos por falhas de segurança originadas em dispositivos infectados do Usuário ou interceptações ilegais de rede por terceiros.
            </p>
          </div>
        </div>

        {/* COMPARTILHAMENTO COM TERCEIROS */}
        <div className="bg-white p-8 sm:p-10 rounded-[32px] border border-slate-100 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.05)]">
          <h2 className="flex items-center gap-3 text-lg font-black text-slate-900 uppercase tracking-wide mb-4">
            <Share2 size={24} className="text-purple-500" /> 
            3. Compartilhamento com Terceiros
          </h2>
          <p className="text-sm leading-relaxed text-slate-600 font-medium mb-4">
            A natureza do Agenda Sincro exige integração constante com APIs de terceiros. Ao utilizar o nosso serviço, você compreende e autoriza o tráfego técnico de dados para as seguintes infraestruturas:
          </p>
          <ul className="flex flex-col gap-3 text-sm text-slate-600 font-medium">
            <li className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-purple-500 shrink-0"></div>
              <strong>Google LLC:</strong> Para armazenamento bidirecional e leitura da sua agenda.
            </li>
            <li className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-purple-500 shrink-0"></div>
              <strong>WhatsApp / Meta:</strong> Através de gateways de API autorizados para o disparo automatizado das mensagens.
            </li>
            <li className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-purple-500 shrink-0"></div>
              <strong>Cloud Hosting:</strong> Provedores de nuvem onde nossos servidores de banco de dados e aplicação estão hospedados.
            </li>
          </ul>
        </div>

        {/* RETENÇÃO E EXCLUSÃO */}
        <div className="bg-white p-8 sm:p-10 rounded-[32px] border border-slate-100 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.05)]">
          <h2 className="flex items-center gap-3 text-lg font-black text-slate-900 uppercase tracking-wide mb-4">
            <Lock size={24} className="text-indigo-500" /> 
            4. Retenção e Exclusão de Dados
          </h2>
          <p className="text-sm leading-relaxed text-slate-600 font-medium">
            Os dados essenciais de funcionamento são mantidos de forma segura enquanto a sua conta estiver ativa. Após a solicitação de cancelamento, os dados do banco local podem ser mantidos por um período de segurança (grace period) para fins de recuperação em caso de arrependimento, sendo devidamente anonimizados ou deletados permanentemente após este prazo estipulado por lei.
          </p>
        </div>

      </div>
    </div>
  );
};

export default PoliticaPrivacidade;